import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import { AuthService } from 'src/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    await new Promise((resolve) => {
      this.authService.onAuthReady(() => {
        resolve(undefined);
      });
    });

    if (!this.authService.user) {
      // Preserve existing redirect param if present (e.g., from OAuth flow)
      const existingRedirect = new URLSearchParams(document.location.search).get('redirect');
      // Include query string so OAuth session/subdomain params are preserved
      const redirect = existingRedirect || document.location.pathname + document.location.search;

      this.router.navigate(['/login'], {
        queryParams: { redirect },
      });

      return false;
    }

    return true;
  }
}
